import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableOnlyLoyalty',
  initialState: false,
  reducers: {
    setEnableOnlyLoyalty(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableOnlyLoyalty } = slice.actions;

export default slice.reducer;
